import React from 'react';
import { Text, TextPriority } from 'wix-ui-tpa/cssVars';
import { classes } from '../../AddonsDetails.st.css';
import { SlotAddOn, SelectedAddons } from '../../../../../../utils/state/types';
import { AddonsDetailsDataHooks } from '../../datahooks';
import { AddonSelector } from '@wix/bookings-viewer-ui';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { PriceUtils } from '@wix/bookings-uou-mappers';
import { useFormComponentContext } from '../../../../Hooks/useFormComponentContext';

export const GroupAddons = ({
  name,
  maxQuantity,
  addOns,
  selectedAddons,
  onAddonSelect,
  onAddonQuantityChange,
  prompt,
}: {
  name: string;
  maxQuantity?: number;
  addOns?: SlotAddOn[];
  selectedAddons: SelectedAddons;
  onAddonSelect: (addonId: string, isSelected: boolean) => void;
  onAddonQuantityChange: (addonId: string, quantity: number) => void;
  prompt?: string;
}) => {
  const { t } = useTranslation();
  const { dateRegionalSettingsLocale } = useFormComponentContext();

  return (
    <>
      <Text
        className={classes.groupName}
        data-hook={AddonsDetailsDataHooks.GROUP_NAME}
      >
        {name}
      </Text>
      {prompt && (
        <Text
          className={classes.groupSubTitle}
          data-hook={AddonsDetailsDataHooks.GROUP_PROMPT}
        >
          {prompt}
        </Text>
      )}
      {maxQuantity && (
        <Text
          priority={TextPriority.secondary}
          className={classes.groupLimitation}
        >
          {t('app.bookings-form.add-ons.group.max-limit', { maxQuantity })}
        </Text>
      )}
      <div className={classes.addonsContainer}>
        {addOns?.map((addOn, addonIndex) => {
          const selectedAddon = selectedAddons[addOn.id!];
          return (
            <AddonSelector
              name={addOn.name!}
              price={
                addOn.price
                  ? t('app.bookings-form.add-ons.plus.price', {
                      price: PriceUtils.getFormattedCurrency({
                        price: Number(addOn.price),
                        currency: addOn.currency!,
                        locale: dateRegionalSettingsLocale,
                        currencyDisplay: 'symbol',
                      }),
                    })
                  : ''
              }
              hasQuantity={selectedAddon && (addOn.maxQuantity ?? 1) > 1}
              maxQuantity={addOn.maxQuantity ?? undefined}
              quantity={selectedAddon?.quantity}
              isFirstAddon={addonIndex === 0}
              onChange={(isSelected: boolean) =>
                onAddonSelect(addOn.id!, isSelected)
              }
              onCounterChange={(quantity: number) =>
                onAddonQuantityChange(addOn.id!, quantity)
              }
              checkboxProps={{
                checked: !!selectedAddon,
                disabled:
                  !selectedAddon &&
                  Object.keys(selectedAddons).length === maxQuantity,
              }}
            />
          );
        })}
      </div>
    </>
  );
};
